import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class CreateResourceResponse {
  @jsonMember(String)
  public readonly id!: Guid;
}
